import React from 'react';

import ListItemIcon from '@material-ui/core/ListItemIcon';
import ReceiptIcon from '@material-ui/icons/Receipt';
import AutorenewIcon from '@material-ui/icons/Autorenew';
import EditIcon from '@material-ui/icons/Edit';
import LocalMallIcon from '@material-ui/icons/LocalMall';
import MotorcycleIcon from '@material-ui/icons/Motorcycle';
import HistoryIcon from '@material-ui/icons/History';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import BlockIcon from '@material-ui/icons/Block';
import ErrorIcon from '@material-ui/icons/Error';
import UndoIcon from '@material-ui/icons/Undo';
import PersonIcon from '@material-ui/icons/Person';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import AssignmentReturnIcon from '@material-ui/icons/AssignmentReturn';
import AssessmentIcon from '@material-ui/icons/Assessment';
import ProvidedIcon from '../images/PrevistoIcon';
const stringToIcon = {
  'dashboard': AssessmentIcon,
  'new-orders': ReceiptIcon,
  'new-orders-criado': ReceiptIcon,
  'new-orders-incluido': ReceiptIcon,
  'new-orders-visualizado': ReceiptIcon,
  'edited': EditIcon,
  'picking': AutorenewIcon,
  'in-edition': EditIcon,
  'history': HistoryIcon,
  'ready-to-go': LocalMallIcon,
  'shipping': MotorcycleIcon,
  'returning-to-storage': AssignmentReturnIcon,
  'paid': MonetizationOnIcon,
  'invoice': ReceiptIcon,
  'concluded': CheckCircleOutlineIcon,
  'canceled': BlockIcon,
  'canceled-from-store': BlockIcon,
  'returned': UndoIcon,
  'associate': PersonIcon,
  'withdrawn': CheckCircleOutlineIcon,
  'delivered': CheckCircleOutlineIcon,
  'confirmed-change': EditIcon,
  'return-to-stock': AssignmentReturnIcon,
  'estimated': ProvidedIcon
}

export default class DynamicIcon extends React.Component {
  render() {
    const { icon, list, children, ...props } = this.props;
    const Icon = stringToIcon[icon] || ErrorIcon;

    if (list) {
      return (
        <ListItemIcon>
          <Icon {...props}>            
            {children}
          </Icon>
        </ListItemIcon>
      )
    }

    return (
      <Icon {...props}>        
        {children}
      </Icon>
    )
  }
}
